import { gql } from '@apollo/client';

export const RETURN_REASON_SET_FRAGMENT_RAW = `
    id
    name
    reasons {
      id
      labels {
        language
        body
      }
      requiresAttachingPhoto
      requiresAddingDescription
      shippingCostAlwaysFree
      exchangeShippingCostAlwaysFree
    }
`;

export const RETURN_REASON_SET_FRAGMENT = gql`
  fragment ReturnReasonSet on ReasonSetObject {
     ${RETURN_REASON_SET_FRAGMENT_RAW}
  }
`;

export const RETURN_INSTRUCTION_SET_FRAGMENT_RAW = `
    id
    name
    labels {
      language
      body
    }
    details {
      language
      body
    }
    steps {
      id
      labels {
        language
        body
      }
    }
`;

export const RETURN_INSTRUCTION_SET_FRAGMENT = gql`
    fragment ReturnInstructionSet on InstructionSetObject {
        ${RETURN_INSTRUCTION_SET_FRAGMENT_RAW}
    }
`;

export const BRAND_TRANSLATIONS_FRAGMENT = gql`
  fragment BrandTranslations on TranslationObject {
    id
    language
    links {
      returnToStore
      termsAndConditions
      returnPolicyPage
      contactsPage
      browseOurStore
    }
    values {
      returnsAndExchanges
      orderOrTrackingNumber
      postCodeOrPhone
      yourEmail
      enterPortal
      loginPage_orCondition
      loginWithEmail
      loginWithOrder
      returnToStore
      successfulEmail
      emailNotFound
      orderDataInvalid
      questionsAndAnswers
      returnExchangeProduct
      order
      inTransit
      returnUntil
      orderList_notReturnable
      returned
      selectAtLeastOneItem
      itemsSelected
      start
      trackOrder
      trackReturn
      productQuantityOutOfTotal
      selectReason
      allSame
      provideDetails
      description
      dropClickAddImage
      uploadImagesFormat
      return
      exchanges
      removeFromReturnList
      youCanRemoveFromList
      back
      remove
      reason_notReturnable
      contactUs
      skipItem
      selectExchangeProduct
      price
      selectVariant
      exchange_orCondition
      returnInstead
      confirm
      oneVariant
      exchangeDetailsLabel
      exchangeDetails
      outOfStock
      sameVariant
      sameVariantText
      exchange
      exchange_cancel
      exchangeForAnotherProduct
      cantFindDesiredVariant
      searchExchangeProduct
      wantToExchange
      suggestProductsForYou
      loadMore
      itemsWantToExchange
      noProductsSelected
      availableCredit
      youWillNeedToPay
      exchange_add
      exchange_confirm
      exchange_skip
      searchProduct
      whatToSearch
      browseOurStore
      noResultsFound
      selectReturnRefundMethod
      methodSelection_returnMethod
      returnTo
      parcelMachine
      here
      physicalStore
      returnWith
      courierPickup
      ownCourier
      methodSelection_refundMethod
      storeCredit
      creditForFuture
      getBonus
      free
      freeShipping
      originalPaymentMethod
      receiveRefundOriginalPaymentMethod
      refundAsStoreCredit
      refundToOriginalPaymentMethod
      continue
      address
      city
      postcode
      phoneNumber
      confirmNewAddress
      confirmPhoneNumber
      cancel
      reviewAndConfirm
      returningItems
      itemsToReceive
      summary
      summary_returnMethod
      summary_refundMethod
      returnValue
      newItemValue
      shipping
      bonus
      details
      youWillReceive
      toBePaid
      total
      termsAndConditionsText
      termsAndConditions
      submit
      labelReady
      clickButtonForReturnLabel
      printReturnLabel
      printReturnSlip
      whatIsNext
      instructions
      returnPolicy
      returnProcessed
      packItems
      refundSummary
      receiveRefundAmount
      exchangeSummary
      totalExchangeCost
      pendingPayment
      payPendingPayment
      payPendingInvoice
    }
  }
`;

export const FETCH_SINGLE_RULE_FRAGMENT = gql`
  fragment FetchSingleRuleQueryFragment on ReturnRulesObjectFind {
    rules {
      id
      name
      condition {
        logOp
        conditions {
          logOp
          conditions {
            op
            param
            type
            value
          }
          op
          param
          type
          value
        }
      }
      isDraft
      allowSpecialActions
      useExchangeCouriers
      specialActionType
      translations {
        returnTogether {
          en
          bg
          ca
          cs
          da
          de
          el
          es
          et
          fi
          fr
          ga
          hr
          hu
          it
          lt
          lv
          nl
          no
          pl
          pt
          ro
          sk
          sl
          sv
        }
      }
      allowReturns
      allowExchanges
      allowDelpuReturn
      daysToReturnOrExchange
      returnReasonSet {
        id
        name
        store
        reasons {
          id
          requiresAttachingPhoto
          requiresAddingDescription
          shippingCostAlwaysFree
          exchangeShippingCostAlwaysFree
        }
      }
      isActive
      store
      createdAt
      updatedAt
      exchangeTrigger
      allowExchangeToOtherProduct
      exchangeCouriers {
        id
        type
        courierId
        courierMethodId
        dropOffPointUrl
        courierAlias
        paymentType
        courierMethodPricing
        totalPayment
        shouldGenerateReturnSheet
        instructionSet {
          id
          name
        }
      }
      allowCustomerCourier
      customerCourierInstructionSet {
        id
        name
        store
        labels {
          language
          body
        }
        details {
          language
          body
        }
        steps {
          id
        }
      }
      customCourierDropOffPointUrl
      hasCustomerCourierReturnSheet
      allowCustomerDeliverToStore
      deliverToStoreInstructionSet {
        id
        name
        store
      }
      deliverToStoreDropOffPointsUrl
      hasCustomerDeliveryReturnSheet
      allowStoreCourier
      myCouriers {
        id
        type
        courierId
        courierMethodId
        dropOffPointUrl
        courierAlias
        paymentType
        courierMethodPricing
        totalPayment
        shouldGenerateReturnSheet
        instructionSet {
          id
          name
        }
      }
      deliverToWarehouse
      warehouseOption
      allowRefundOriginalPayment
      refundAutomaticallyToCMS
      dontRefundShippingCost
      allowRefundAsCredit
      refundCreditOptions {
        hasFreeShipping
        hasCredit
        bonusType
        minimumOrderValue
        bonusAmount
        hasCoupon
        couponTrigger
        discountType
        bonusPercentage
        maximumBonus
      }
      exchangeRecommendation
      pushExchange
      exchangeType
    }
    count
  }
`;
